module.exports = __webpack_public_path__ + "img/logo_dipartimento.faf4bb1a.jpg";